import { Localized, useLocalization } from '@fluent/react';

import { InputFormik } from '#/components/controls/Input';
import { formatTextAsNumberOnly } from '#/utils/formatter';

export const DimensionsSpecificationForm: React.FC<DimensionsSpecificationFormProps> = ({
  name,
}) => {
  const namePrefix = name ? `${name}.` : '';
  const { l10n } = useLocalization();

  return (
    <div className="grid grid-cols-3 gap-4">
      <div>
        <Localized id="height" attrs={{ placeholder: true }}>
          <InputFormik
            formatter={formatTextAsNumberOnly}
            label={l10n.getString('height')}
            name={`${namePrefix}height.value`}
            rightAddon="cm"
          />
        </Localized>
      </div>

      <div>
        <Localized id="length" attrs={{ placeholder: true }}>
          <InputFormik
            formatter={formatTextAsNumberOnly}
            label={l10n.getString('length')}
            name={`${namePrefix}length.value`}
            rightAddon="cm"
          />
        </Localized>
      </div>

      <div>
        <Localized id="width" attrs={{ placeholder: true }}>
          <InputFormik
            formatter={formatTextAsNumberOnly}
            label={l10n.getString('width')}
            name={`${namePrefix}width.value`}
            rightAddon="cm"
          />
        </Localized>
      </div>
    </div>
  );
};
export type DimensionsSpecificationFormProps = {
  name: string;
};
